import Flex from 'components/common/Flex';
import { ChatContext } from 'context/Context';
import React, { useContext, memo, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';
import ChatProvider from './ChatProvider';
import ChatContent from './content/ChatContent';
import ChatSidebar from './sidebar/ChatSidebar';
import './elvis.css';

const ChatTab = () => {
  const { threads, setCurrentThread, currentThread, setScrollToBottom } = useContext(ChatContext);
  const [hideSidebar, setHideSidebar] = useState(false);
  const handleSelect = e => {
    setHideSidebar(false);
    const thread = threads[parseInt(e)];
    setCurrentThread(thread);
    setScrollToBottom(true);
  };
  const activeKey = threads.findIndex(x => x?.id === currentThread?.id) || 0;

  return (
    <Tab.Container
      id="left-tabs-example"
      defaultActiveKey={activeKey}
      activeKey={activeKey}
      onSelect={handleSelect}
    >
      <Card className="card-chat overflow-hidden">
        <Card.Body as={Flex} className="p-0 h-100">
          <ChatSidebar hideSidebar={hideSidebar} />
          <ChatContent setHideSidebar={setHideSidebar} />
        </Card.Body>
      </Card>
    </Tab.Container>
  );
};

const ElvisHistory = () => {
  return (
    <ChatProvider>
      <ChatTab />
    </ChatProvider>
  );
};

export default memo(ElvisHistory);